import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/ui/header";
import Footer from "./components/ui/footer";

const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
